import { render, staticRenderFns } from "./NewsletterSelector.vue?vue&type=template&id=31044091&scoped=true"
import script from "./NewsletterSelector.vue?vue&type=script&lang=ts"
export * from "./NewsletterSelector.vue?vue&type=script&lang=ts"
import style0 from "./NewsletterSelector.vue?vue&type=style&index=0&id=31044091&prod&lang=scss"
import style1 from "./NewsletterSelector.vue?vue&type=style&index=1&id=31044091&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31044091",
  null
  
)

export default component.exports